<!--单选 SCQ-->
<template>
  <div class="question-editor">
    <div class="question-pd">
      <div class="question-header">
        <div class="question-header-left">
          <div>
            <span v-if="isMust" class="asterisk">*</span>
            <span class="question-number">{{ `${index + 1}、` }}</span>
          </div>
          <div class="question-select">
            <span>多选</span>
          </div>
          <div class="question-text">
            <div class="add-batch" @click="handleAnswerAndScore">
              答案与分值
            </div>
          </div>
        </div>
        <div class="question-header-right">
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596666801.png"
            lazy-load
            class="image-up"
            @click="handleOperateClick(2)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596715787.png"
            lazy-load
            class="image-down"
            @click="handleOperateClick(3)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596748508.png"
            lazy-load
            class="image-delete"
            @click="handleOperateClick(4)"
          />
        </div>
      </div>

      <div
        class="textarea-box"
        style="
          width: 100%;
          background: #ffffff;
          border: 1px solid #dcdde0;
          border-radius: 4px;
          padding: 12px;
          box-sizing: border-box;
          margin-top: 10px;
        "
      >
        <textarea
          placeholder-class="textarea-placeholder"
          v-model="caseProblem"
          placeholder="请选择一个选项"
          maxlength="500"
          auto-height
          @input="handleUpdate"
          @focus="isFocusIndex = '-1'"
          @blur="state.isFocusIndex = ''"
          rows="2"
          style="width: 100%; resize: none"
        ></textarea>
        <div
          class=""
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 8px;
          "
        >
          <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1737857957020.png"
            mode=""
            style="width: 18px; height: 18px; cursor: pointer"
            @click="handleCaseProblemImg"
          />
          <div @click="clearQuestion" class="clear-btn">清空</div>
        </div>
      </div>

      <div class="question-images">
        <div
          v-for="(item, idx) in images"
          :key="idx"
          style="margin-top: 10px; position: relative"
        >
          <img :src="item" style="width: 100%; display: block" />
          <img
            src="@/assets/images/guanbi.png"
            class="guanbi"
            @click="handleDeleteQuestionImage(idx)"
          />
        </div>
      </div>

      <div class="options">
        <div v-for="(option, idx) in list" :key="idx">
          <div class="option-item">
            <div class="option-item-top">
              <div class="option-item-top-left">
                <img
                  v-if="list.length > 2"
                  @click="delItem(idx)"
                  class="del1"
                  src="https://ossfytp.mustke.com/image/newStyleImages/del-red.svg"
                />
                <img
                  v-else
                  class="del1"
                  src="https://ossfytp.mustke.com/image/newStyleImages/del-gray.svg"
                />
              </div>
              <div
                class="option-item-top-right"
                :style="{
                  border:
                    inputFocusIndex === `a${idx}`
                      ? '1px solid rgba(58,96,255,0.5)'
                      : '1px solid #DCDDE0',
                }"
              >
                <div class="option-item-top-right-up">
                  <input
                    type="text"
                    :placeholder="'选项' + (idx + 1)"
                    v-model="option.text"
                    @focus="inputFocusIndex = 'a' + idx"
                    @blur="inputFocusIndex = ''"
                    @input="handleUpdate"
                  />
                  <div class="option-item-top-right-right">
                    <div class="true-answer">
                      {{ option.isCorrect ? "正确答案" : "" }}
                    </div>
                    <img
                      src="https://ossfastmake.mustke.com/qrCode/tupian/1737857957020.png"
                      style="width: 18px; height: 18px; cursor: pointer"
                      @click="handleItemImage(idx)"
                    />
                  </div>
                </div>

                <div class="question-images">
                  <div
                    v-for="(imgItem, imgIndex) in option.img_path"
                    :key="imgIndex"
                    class="question-images-box"
                    style="
                      margin-top: 10px;
                      position: relative;
                      margin-bottom: 10px;
                    "
                  >
                    <img :src="imgItem" class="thumbnail-image" />
                    <div class="fangda-box">查看图片</div>
                    <img
                      src="@/assets/images/guanbi.png"
                      class="guanbi"
                      @click.stop="handleDeleteItemImage(idx, imgIndex)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="fangda-popup" v-if="fangdaShow" @click="fangdaClose">
        <div class="popup-content" @click.stop>
          <img
            src="@/assets/images/guanbi.png"
            class="popup-guanbi"
            @click="fangdaClose"
          />
          <div class="popup-scroll">
            <div>{{ fangdaTitle }}</div>
            <img :src="fangdaImgUrl" style="width: 100%" />
          </div>
        </div>
      </div>

      <div class="add-view">
        <div class="required">
          <el-checkbox v-model="isMust" @change="handleUpdate"
            >必选题</el-checkbox
          >
        </div>
        <div @click="addOption" class="add-btn">
          <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1737858857723.png"
            style="width: 13px; height: 13px"
          />
          <span>添加选项 {{ list.length + "/20" }}</span>
        </div>
        <div @click="batchAddOptions" class="add-batch">批量添加</div>
      </div>
    </div>

    <div class="option-settings">
      <span></span>
      <el-checkbox v-model="ifRandomize" @change="handleUpdate"
        >选项随机排列</el-checkbox
      >
    </div>

    <div v-if="type === 1" class="question-footer">
      <!-- <div class="cancel-btn" @click="cancelClick">取消</div> -->
      <div class="save-btn" @click="saveClick">保存</div>
    </div>

    <PopupInput
      :showDialog="showpopup"
      :title="'批量添加'"
      :aContent="''"
      :type="1"
      @close="showpopup = false"
      @confirm="bitchConfirm"
    ></PopupInput>

    <!-- <uploadImage
      :show="showUpload"
      :maxCount="1"
      :images="0"
      @upload-close="showUpload = false"
      @upload-success="handleUploadComplete"
    /> -->

    <ExamAnswerSetting
      :show="showSetting"
      :dataObj="settingObj"
      @close="showSetting = false"
      @confirm="handleSettingChange"
    />

    <input
      type="file"
      ref="fileInput"
      accept="image/*"
      style="display: none"
      @change="handleFileChange"
    />
  </div>
</template>

<script>
import axios from "axios";
import baseURL from "../../utils/bsaeUrl";
import PopupInput from "@/components/PopupInput/PopupInput.vue";
import ExamAnswerSetting from "@/components/ExamAnswerSetting/ExamAnswerSetting.vue";
export default {
  name: "ExamEditSCQ",
  components: {
    PopupInput,
    // uploadImage: () => import("@/components/uploadImage"),
    ExamAnswerSetting,
  },
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: 0,
    },
    updateType: {
      type: Number,
      default: 0,
    },
    uuid: {
      type: [String, Number],
      default: "",
    },
    type: {
      type: Number,
      default: 1, // 1 添加问卷 2 添加题库
    },
  },
  data() {
    return {
      list: [],
      ifRandomize: false,
      isMust: false,
      showpopup: false,
      showUpload: false,
      uploadIndex: 0,
      images: [],
      caseProblem: "",
      isFocusIndex: "",
      inputFocusIndex: "",
      showSetting: false,
      settingObj: {},
      questionScore: 0,
      explanation: "",
      scoringMethod: 0,
      fangdaShow: false,
      fangdaImgUrl: "",
      fangdaTitle: "",
      dataObj: {},
    };
  },
  watch: {
    params: {
      handler(newValue) {
        if (newValue && Object.keys(newValue).length > 0) {
          this.dataObj = newValue;
          this.caseProblem = newValue.caseProblem || "";
          this.list = JSON.parse(newValue.chooseList).list.map((item) => ({
            ...item,
            is_fill: item.is_fill === 1,
          }));
          this.ifRandomize = newValue.ifRandomize === 1;
          this.isMust = newValue.isMust === 1;
          this.images = JSON.parse(newValue.caseProblemImg || "[]");
          this.questionScore = newValue.questionScore || 0;
          this.explanation = newValue.analysis || "";
          this.scoringMethod = newValue.scoringMethod || 0;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    clearQuestion() {
      this.caseProblem = "";
      this.handleUpdate();
    },
    handleOperateClick(type) {
      this.$emit(
        "operate",
        JSON.stringify({
          type: type,
          index: this.index,
        }),
      );
    },
    addOption() {
      if (this.list.length < 20) {
        this.list.push({
          id: "",
          text: "",
          isChoose: false,
          img_path: [],
          is_fill: 0,
          fill_prompt: "",
          newDate: true,
        });
        this.handleUpdate();
      } else {
        this.$message.error("最多只能添加20个选项");
      }
    },

    batchAddOptions() {
      this.showpopup = true;
    },

    bitchConfirm(e) {
      this.showpopup = false;
      const count = e.split("\n").filter((item) => item.trim() !== "").length;
      if (count > 20 - this.list.length) {
        this.$message.error("最多只能添加20个选项");
        return;
      }
      const list = e
        .split("\n")
        .filter((item) => item.trim() !== "")
        .map((item) => ({
          id: "",
          text: item,
          isChoose: false,
          img_path: [],
          is_fill: 0,
          fill_prompt: "",
          newDate: true,
        }));
      this.list = this.list.concat(list);
      this.handleUpdate();
    },

    delItem(index) {
      if (this.updateType === 1) {
        if (this.list[index].newDate) {
          this.list.splice(index, 1);
        } else {
          this.$message.error("限制性修改状态下，不能删除之前的数据!");
        }
      } else {
        this.list.splice(index, 1);
      }
      this.handleUpdate();
    },

    handleCaseProblemImg() {
      this.uploadIndex = -1;
      this.$refs.fileInput.click();
    },
    handleItemImage(index) {
      this.uploadIndex = index;
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append("file", file); // "file" 对应后端接收的字段名
      formData.append("uuid", this.uuid);
      this.$refs.fileInput.value = "";
      axios
        .post(baseURL + "/PCwj/file/uploads", formData, {
          headers: {
            "Content-Type": "multipart/form-data", // 必须设置
            token: localStorage.getItem("token"),
          },
        })
        .then((response) => {
          this.$message.success("上传成功！");
          if (this.uploadIndex === -1) {
            this.images = [response.data.urls];
          } else {
            this.list[this.uploadIndex].img_path = [response.data.urls];
          }
          this.handleUpdate();
        })
        .catch((error) => {
          if (axios.isCancel(error)) {
            console.log("上传已取消:", error.message);
          } else {
            this.$message.error("上传失败！");
          }
        });
    },
    handleUploadComplete(e) {
      if (this.uploadIndex === -1) {
        this.images = e;
      } else {
        this.list[this.uploadIndex].img_path = e;
      }
      this.showUpload = false;
      this.handleUpdate();
    },

    handleDeleteQuestionImage(index) {
      this.images.splice(index, 1);
      this.handleUpdate();
    },

    handleDeleteItemImage(index, imgIndex) {
      this.list[index].img_path.splice(imgIndex, 1);
      this.handleUpdate();
    },

    handleAnswerAndScore() {
      this.settingObj = {
        ...this.dataObj,
        chooseList: JSON.stringify({
          list: this.list.map((item, index) => ({
            ...item,
            is_fill: item.is_fill ? 1 : 0,
            text: item.text === "" ? `选项${index + 1}` : item.text,
          })),
        }),
        questionScore: this.questionScore,
        explanation: this.explanation,
        scoringMethod: this.scoringMethod,
      };
      this.showSetting = true;
    },

    handleSettingChange(e) {
      const data = JSON.parse(e);
      this.questionScore = data.questionScore;
      this.explanation = data.explanation;
      this.scoringMethod = data.scoringMethod;

      const chooseList = JSON.parse(data.chooseList);
      this.list = this.list.map((item, index) => ({
        ...item,
        isCorrect: chooseList.list[index].isCorrect,
      }));

      this.updateDataObj();
      this.$emit(
        "update",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
      this.showSetting = false;
    },

    cancelClick() {
      this.$emit(
        "cancel",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },

    saveClick() {
      if (this.caseProblem.includes(" ") && this.caseProblem.trim() === "") {
        this.$message.error("请输入题目");
        return;
      }

      const isCorrect = this.list.some((item) => item.isCorrect);
      if (!isCorrect) {
        this.$message.error("请设置正确答案");
        return;
      }

      // this.updateDataObj();
      this.dataObj.isMust = this.isMust ? 1 : 0;
      this.dataObj.caseProblemImg = JSON.stringify(this.images);
      this.dataObj.ifRandomize = this.ifRandomize ? 1 : 0;
      this.dataObj.caseProblem =
        this.caseProblem === "" ? "请选择一个选项" : this.caseProblem;
      this.dataObj.questionScore = this.questionScore;
      this.dataObj.analysis = this.explanation;
      this.dataObj.scoringMethod = this.scoringMethod;
      this.dataObj.chooseList = JSON.stringify({
        list: this.list.map((item, index) => ({
          ...item,
          is_fill: item.is_fill ? 1 : 0,
          text: item.text === "" ? `选项${index + 1}` : item.text,
        })),
      });
      this.$emit(
        "save",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },

    handleUpdate() {
      this.updateDataObj();
      this.$emit(
        "update",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },

    updateDataObj() {
      this.dataObj.isMust = this.isMust ? 1 : 0;
      this.dataObj.caseProblemImg = JSON.stringify(this.images);
      this.dataObj.ifRandomize = this.ifRandomize ? 1 : 0;
      this.dataObj.caseProblem = this.caseProblem;
      this.dataObj.questionScore = this.questionScore;
      this.dataObj.analysis = this.explanation;
      this.dataObj.scoringMethod = this.scoringMethod;
      this.dataObj.chooseList = JSON.stringify({
        list: this.list.map((item, index) => ({
          ...item,
          is_fill: item.is_fill ? 1 : 0,
          // text: item.text === "" ? `选项${index + 1}` : item.text,
        })),
      });
    },

    showBigImage(img, option) {
      this.fangdaShow = true;
      this.fangdaImgUrl = img;
      this.fangdaTitle = option.text;
    },

    fangdaClose() {
      this.fangdaShow = false;
      this.fangdaImgUrl = "";
      this.fangdaTitle = "";
    },
  },
};
</script>

<style lang="scss" scoped>
button {
  margin-left: 10px;
}

.clear-btn {
  width: 31px;
  height: 18px;
  background: #ffffff;
  border: 1px solid #3a60ff;
  border-radius: 5px;
  font-size: 11px;
  font-weight: 400;
  text-align: center;
  color: #3a60ff;
  line-height: 18px;
  margin-left: 11px;
  cursor: pointer;
}

.add-view {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.add-btn {
  width: 153px;
  height: 32px;
  background: #ffffff;
  border: 1px solid #00c755;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  cursor: pointer;

  span {
    font-size: 14px;
    font-weight: 400;
    color: #00c755;
    margin-left: 22px;
  }
}

.add-batch {
  height: 20px;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: #509dee;
  line-height: 20px;
  cursor: pointer;
}

.del1 {
  width: 19px;
  height: 19px;
  cursor: pointer;
}

.case-problem-textarea {
  width: 100%;
  min-height: 100px;
  border: none;
  outline: none;
  resize: vertical;
  font-size: 14px;
  color: #4c4a56;
}

.question-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.question-header-left {
  display: flex;
  align-items: center;

  .question-select {
    margin-left: 10px;
    padding: 4px 12px;
    background: #f0f0f0;
    border-radius: 4px;
    font-size: 14px;
  }
}

.question-number {
  font-weight: 600;
  font-size: 16px;
}

.asterisk {
  color: red;
  margin-right: 4px;
}

.question-text {
  display: flex;
  align-items: center;
  margin-left: 10px;

  .add-batch {
    border-bottom: 2px solid #509dee;
  }
}

.option-item-top {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.option-item-top-left {
  padding-top: 10px;
}

.option-item-top-right {
  flex: 1;
  border: 1px solid #dcdde0;
  border-radius: 8px;
  padding: 12px;

  input {
    width: 100%;
    border: none;
    outline: none;
    font-size: 14px;
    color: #4c4a56;
  }
}

.option-item-top-right-up {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.option-item-top-right-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.true-answer {
  color: #00c755;
  font-size: 12px;
  white-space: nowrap;
}

.question-images-box {
  position: relative;
  cursor: pointer;

  &:hover .fangda-box {
    opacity: 1;
  }
}

.thumbnail-image {
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 4px;
}

.fangda-box {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s;
  border-radius: 4px;
}

.guanbi {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.fangda-popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.popup-content {
  position: relative;
  max-width: 90%;
  max-height: 90%;
  background: white;
  border-radius: 8px;
  padding: 20px;
}

.popup-guanbi {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.popup-scroll {
  max-height: 80vh;
  overflow-y: auto;

  img {
    width: 100%;
    margin-top: 10px;
  }
}

.option-settings {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ExamEdit/ExamEditMCQ.vue